// extracted by mini-css-extract-plugin
module.exports = {"subsidiaryContainer":"CommonOwner_subsidiaryContainer__3q2PF","addSubsidiaryBtn":"CommonOwner_addSubsidiaryBtn__2JiUK","alertWarning":"CommonOwner_alertWarning__iPgay"};